import { FC } from 'react';
import Select, { SelectProps } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import { useDictionary } from '@cvt/hooks/useDictionary';


type Country = CVT.Location.Country

type Props = SelectProps<Country> & {
  error?: boolean
  helperText?: string
}

export const CountrySelect: FC<Props> = ({ error, helperText, ...selectProps }) => {
  const dictionary = useDictionary();

  return (
    <FormControl fullWidth size="small" error={error}>
      <Select
        color="primary"
        sx={{
          fieldset: {
            borderColor: '#e2e8f0',
            borderRadius: '10px',
          },
        }}
        {...selectProps}
      >
        {availableCountries.map((countryCode) => (
          <MenuItem value={countryCode}>
            {dictionary.countries[countryCode]}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

const availableCountries: Country[]  = ['US', 'CA'];
